import type { EntityConfig } from '../types'

export const mmAdjustmentEntity: EntityConfig = {
  name: 'mm-adjustment',
  label: 'Adjustment',
  pluralLabel: 'Adjustments',
  status: {
    field: 'status',
    options: [
      { value: 'applied', label: 'Applied', variant: 'success' },
      { value: 'pending', label: 'Pending', variant: 'warning' },
      { value: 'reversed', label: 'Reversed', variant: 'secondary' },
      { value: 'rejected', label: 'Rejected', variant: 'destructive' },
    ],
    filters: [
      { value: 'all', label: 'All' },
      { value: 'applied', label: 'Applied' },
      { value: 'pending', label: 'Pending' },
      { value: 'reversed', label: 'Reversed' },
      { value: 'rejected', label: 'Rejected' },
    ],
    mappings: {
      all: ['applied', 'pending', 'reversed', 'rejected'],
      applied: ['applied'],
      pending: ['pending'],
      reversed: ['reversed'],
      rejected: ['rejected'],
    }
  },
  queryFields: {
    description: { field: 'description', type: 'text' },
    type: { field: 'type', type: 'text' },
    accountName: { field: 'accountName', type: 'text' },
  },
  uiFilterFields: ['status', 'type'],
}
